import '../../../GenericContent/CardBlock/CardBlock.scss';
import './CardGridBlock.scss';

import { createApp, defineAsyncComponent } from 'vue';
import CardGridBlock from './CardGridBlock.vue';

const CardBlockVideo = defineAsyncComponent(
	() => import('../../../GenericContent/CardBlock/CardBlockVideo.vue'),
);

const mountingCardGridBlock = document.querySelector(
	'[data-feature="card-grid-block"]',
);
if (mountingCardGridBlock) {
	const app = createApp({
		name: 'CardGridBlockApp',
	});
	app.component('card-grid-block', CardGridBlock);
	app.component('card-block-video', CardBlockVideo);
	app.mount(mountingCardGridBlock);
}

